export default __webpack_public_path__ + "static/media/message-circle.e2f4da03.svg";